import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR} from '../theme.js';

export function getVirtualsConfig() {
    return {
        palette: {
            [PALETTE_IDS.VIRTUALS]: {
                DESKTOP_SPORT_MENU: {
                    LIST_ITEM_SELECTED_ICON_COLOR: COLOR.BRAND.FOREGROUND4,
                },
                VIRTUALS_NEXT_EVENT_COUNTDOWN_TEXT: COLOR.BRAND.FOREGROUND1,
                VIRTUALS_NEXT_EVENT_COUNTDOWN_BG: COLOR.BRAND.BACKGROUND5,
            },
        },
    };
}
